export const video_hls = () => {
  // console.log("video.js loaded");
};





